import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import FailedIcon from '@material-ui/icons/ErrorOutline';
import CompletedIcon from '@material-ui/icons/CheckCircleOutline';
import './OptimizationStatus.scss';

const OptimizationStatus = ({ value }) => {
  const { status, error, errormsg } = value || {};
  return (
    <Tooltip
      title={error ? errormsg : `Completion code ${status}`}
    >
      <div className={classnames('grb-optimizationstatus', error ? 'grbrsm-optimization-error' : 'grbrsm-optimization-completed')}>
        {error ? (
          <FailedIcon />
        ) : (
          <CompletedIcon />
        )}
      </div>
    </Tooltip>
  );
};

OptimizationStatus.propTypes = {
  value: PropTypes.shape({}),
};

OptimizationStatus.defaultProps = {
  value: 0,
};

export default OptimizationStatus;
